// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project import
import menu from './menu';
import snackbar from './snackbar';
import cartReducer from './cart';
import growerReducer from './grower';
import fpaReducer from './fpas';
import grower6040reducer from './grower6040';
import scheduleAReducer from './scheduleA';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu,
  snackbar,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'mantis-ts-'
    },
    cartReducer
  ),
  grower: growerReducer,
  fpa: fpaReducer,
  grower6040: grower6040reducer,
  scheduleA: scheduleAReducer,
});

export default reducers;
